import moment from 'moment';
import { TimecardRecord } from './TimecardRecord.model';

export class EmployeeAutomaticMessageItem {
	pk: string; //AUTOEMPMSG_{venueKey}
	sk: string; //{JOBID}_{hoursWorkedStart}_{hoursWorkedEnd}
	jobId: number;
	hoursWorkedStart: number;
	hoursWorkedEnd: number;
	active: boolean;
	subjectEnglish: string;
	subjectSpanish: string;
	subjectFrench: string;
	contentEnglish: string;
	contentSpanish: string;
	contentFrench: string;
	created: string;
	lastUpdated: string = moment().format();
	authorUserKey: string;
	timecardIdHistory: EmployeeAutomaticMessageHistory[] = [];

	jobName: string;

	public constructor(init?: Partial<EmployeeAutomaticMessageItem>) {
		Object.assign(this, init);
	}
}

export class EmployeeAutomaticMessageHistory {
	timecardId: string;
	datetime: string;
	timecard: TimecardRecord;

	public constructor(init?: Partial<EmployeeAutomaticMessageHistory>) {
		Object.assign(this, init);
	}
}
